import { GeneralPurchaseDao } from '../../../api/generalPurchase/dao/generalPurchase.dao';
import { GeneralPurchaseRepository } from '../../../api/generalPurchase/repository/generalPurchase.repository';
import {
  TypesActionsGeneralPurchase,
  LIST_GENERAL_PURCHASE,
  SHOW_GENERAL_PURCHASE,
  UPDATE_GENERAL_PURCHASE,
  DELETE_GENERAL_PURCHASE,
  GET_GENERAL_PURCHASES,
  RESET_GENERAL_PURCHASES_STATE,
} from './GeneralPurchaseTypes';
import {
  ResponseGeneralPurchase,
  GeneralPurchase,
} from '../../../types/generalPurchase/GeneralPurchase';

function listGeneralPurchase(
  payload: ResponseGeneralPurchase
): TypesActionsGeneralPurchase {
  return {
    type: LIST_GENERAL_PURCHASE,
    payload,
  };
}

function showGeneralPurchase(
  payload: GeneralPurchase
): TypesActionsGeneralPurchase {
  return {
    type: SHOW_GENERAL_PURCHASE,
    payload,
  };
}

function updateGeneralPurchase(
  payload: GeneralPurchase
): TypesActionsGeneralPurchase {
  return {
    type: UPDATE_GENERAL_PURCHASE,
    payload,
  };
}

function deleteGeneralPurchase(payload: string): TypesActionsGeneralPurchase {
  return {
    type: DELETE_GENERAL_PURCHASE,
    payload,
  };
}

function getGeneralPurchases(
  payload: ResponseGeneralPurchase
): TypesActionsGeneralPurchase {
  return {
    type: GET_GENERAL_PURCHASES,
    payload,
  };
}

export function resetGeneralPurchaseState(): TypesActionsGeneralPurchase {
  return {
    type: RESET_GENERAL_PURCHASES_STATE,
  };
}

export function listGeneralPurchaseAsync(
  numberPage: number,
  limit: number,
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return async function (dispacth: Function) {
    const response = await GeneralPurchaseDao.list(
      accountId,
      numberPage,
      limit,
      search,
      filter
    );
    dispacth(listGeneralPurchase(response.data));
  };
}

export function showGeneralPurchaseAsync(
  id: string,
  accountId: string,
  callback: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralPurchaseDao.show(id, accountId);
      dispatch(showGeneralPurchase(response.data));
    } catch (error) {
      console.log(error);
      callback();
    }
  };
}

export function createGeneralPurchaseAsync(
  form: object,
  callbackSuccess: (generalPuchase: GeneralPurchase) => void,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralPurchaseRepository.create(form);
      callbackSuccess(response.data);
      dispatch(showGeneralPurchase(response.data));
    } catch (error) {
      callbackError();
      console.log(error);
    }
  };
}

export function updateGeneralPurchaseAsync(
  form: object,
  callbackSuccess: Function,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralPurchaseRepository.update(form);

      dispatch(updateGeneralPurchase(response.data));
      callbackSuccess();
    } catch (request) {
      callbackError();
    }
  };
}

export function deleteGeneralPurchaseAsync(
  form: {
    id: string;
    accountId: string;
  },
  callbackSuccess: Function,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      await GeneralPurchaseRepository.delete(form);
      const response = await GeneralPurchaseDao.list(
        form.accountId,
        null,
        null,
        null,
        null
      );
      dispatch(deleteGeneralPurchase(form.id));
      dispatch(listGeneralPurchase(response.data));
      callbackSuccess();
    } catch (error) {
      console.log(error);
      callbackError();
    }
  };
}

export function getGeneralPurchasesAsync(
  numberPage: number,
  limit: number,
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return async function (dispacth: Function) {
    const response = await GeneralPurchaseDao.list(
      accountId,
      numberPage,
      limit,
      search,
      filter
    );
    dispacth(getGeneralPurchases(response.data));
  };
}

export async function getGeneralPurchaseExcel(
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return await GeneralPurchaseDao.getExcel(accountId, search, filter);
}
